import { createSelector } from '@ngrx/store';
import { DotCMSConfigurationParams } from 'dotcms/src/lib/models';

import {
  getDotCmsApiConfigurationFromEnv,
  getDotCmsUnRegisteredCustomerPersona,
} from 'ish-core/store/core/configuration';
import { getServerConfigParameter } from 'ish-core/store/core/server-config';
import { getCustomerAttributes, getUserAuthorized } from 'ish-core/store/customer/user';

import { DotCmsConfigurationHelper } from '../../models/configuration/dot-cms-configuration.helper';
import { CustomDotCmsIcmServerConfig } from '../../models/configuration/dotcms-configuration.model';
import { getDotCmsState } from '../dot-cms-store';

export const getDotCmsConfiguration = createSelector(getDotCmsState, state => state?.configuration);

export const getDotCmsApiConfiguration = createSelector(getDotCmsConfiguration, state => state?.apiConfiguration);

export const getDotCmsApiEndpoint = createSelector(getDotCmsApiConfiguration, state => state?.host);

export const getDotCmsApitoken = createSelector(getDotCmsApiConfiguration, state => state?.token);

export const getDotCmsHostId = createSelector(getDotCmsApiConfiguration, state => state?.hostId);

export const getDotCmsAvailableLanguages = createSelector(getDotCmsConfiguration, state => state?.fallbackLanguages);

export const getDotCmsSelectedLanguage = createSelector(getDotCmsConfiguration, state => state?.language);

export const getDotcmsSelectedLanguageId = createSelector(getDotCmsSelectedLanguage, language => language?.id);

export const isDotCmsConfigurationLoaded = createSelector(getDotCmsConfiguration, configuration => !!configuration);

export const getCurrentDotCmsApiConfiguration = createSelector(
  getServerConfigParameter<CustomDotCmsIcmServerConfig>('dotcms'),
  getDotCmsApiConfigurationFromEnv,
  (icmConfig, envConfig): DotCMSConfigurationParams =>
    icmConfig?.endPoint && icmConfig.apiToken && icmConfig.hostId
      ? { host: icmConfig.endPoint, token: icmConfig.apiToken, hostId: icmConfig?.hostId }
      : envConfig
);

export const getDotCmsPersonaIdFromIcmPreference = createSelector(
  getServerConfigParameter<string>('dotcms.dotcmsUnRegisteredCustomerPersona'),
  state => state
);

export const getDotCmsPersonaId = createSelector(getDotCmsConfiguration, configuration => configuration?.personaId);

export const getCurrentDotCmsPersona = createSelector(
  getUserAuthorized,
  getDotCmsUnRegisteredCustomerPersona,
  getDotCmsPersonaIdFromIcmPreference,
  getCustomerAttributes,
  (isLoggedIn, envPersonaId, icmPersonaId, customerAttributes) => {
    if (isLoggedIn) {
      const attributePersonaId = DotCmsConfigurationHelper.getCustomerAttributePersonaId(customerAttributes);
      if (attributePersonaId) return attributePersonaId;
      //No fallback persona for logged in user at this time.
      return;
    }

    return icmPersonaId || envPersonaId;
  }
);

export const isDotCmsCanMakeApiCall = createSelector(getDotCmsConfiguration, state => state.canMakeApiCall);
